import { render, staticRenderFns } from "./kefu.vue?vue&type=template&id=4e40acb2"
import script from "./kefu.vue?vue&type=script&lang=js"
export * from "./kefu.vue?vue&type=script&lang=js"
import style0 from "./kefu.vue?vue&type=style&index=0&id=4e40acb2&prod&lang=scss&scord=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports